import merge from 'lodash/merge'
import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VuePlyr from 'vue-plyr'
import Ncs from 'ncs'
import config from '../search/ncs_config'
import csvElementFields from '../search/csv_element_fields'
import KwicHeader from './KwicHeader'
import ContextResult from './ContextResult'
import ContextHeader from './ContextHeader'
import PageSelector from './PageSelector'
import BackButton from './BackButton'
import FullFrequencyResult from './FullFrequencyResult'

Vue.use(VueAxios, axios)
Vue.use(VuePlyr, {plyr: {fullscreen: {enabled: false}}, emit: ['ended']})

const components = {
  ...Ncs.defaultComponents,
  NcsContextResult: ContextResult,
  NcsContextDocumentHeader: ContextHeader,
  NcsKwicResultHeader: KwicHeader,
  NcsPageSelector: PageSelector,
  NcsBackButton: BackButton,
  NcsFullFrequencyResult: FullFrequencyResult
}

Vue.use(Ncs, {
  config: merge(gon.config, config),
  components,
  csvElementFields
})

document.addEventListener('DOMContentLoaded', () => {
  // https://github.com/rails/webpacker/issues/1015
  const csrfToken = document.querySelector("meta[name=csrf-token]") || {content: 'no-csrf-token'}
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken.content
})

export {Vue, Ncs}